/**
 * 复制文本到剪贴板
 * @param {string} text - 需要复制的文本
 * @returns {Promise<boolean>} 复制成功返回true，失败false
 */
export async function copyToClipboard(text) {
  // 优先使用现代 Clipboard API
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (err) {
      console.error('Clipboard API复制失败:', err);
    }
  }

  // 降级方案：创建临时textarea兼容旧浏览器、非https环境
  const textarea = document.createElement('textarea');
  textarea.value = text;
  // 移出可视区域，不展示
  textarea.style.position = 'absolute';
  textarea.style.left = '-9999px';
  textarea.style.top = '-9999px';
  document.body.appendChild(textarea);

  textarea.select();
  textarea.setSelectionRange(0, textarea.value.length);

  let success = false;
  try {
    success = document.execCommand('copy');
  } catch (err) {
    console.error('execCommand复制失败:', err);
  }

  document.body.removeChild(textarea);
  return success;
}

// 使用示例
// copyToClipboard('要复制的内容').then(res=>{
//   if(res) alert('复制成功')
// })
